import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconFlagNetherlands = function IconFlagNetherlands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 25"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h33v25H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941D20",
    fillRule: "evenodd",
    d: "M33 0v8H0V0z",
    clipRule: "evenodd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284787",
    fillRule: "evenodd",
    d: "M33 16v8H0v-8z",
    clipRule: "evenodd"
  }));
};